module.exports = __webpack_public_path__ + "group-image.52ffe152ebf5cefe68bb.png";


//////////////////
// WEBPACK FOOTER
// /Users/bright.ofosu/Documents/brytelabs/seedit-parent/seedit-website/src/assets/images/group-image.png
// module id = ../../../../../src/assets/images/group-image.png
// module chunks = styles